import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import InvitedUsersPage from "../modules/InvitedUsers/InvitedUsersPage";

export function InvitedUsers() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "invited-users-page-title",
    defaultMessage: "Invited users"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <InvitedUsersPage/>;
}
